/*
 * Jira Ticket:
 * Created Date: Wed, 22nd Apr 2020, 19:12:07 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const updateTowerInspectionMutation = gql`
  mutation UpdateTowerInspection(
    $id: ID!
    $reviewerComments: String
    $status: TowerInspectionApprovalStatus!
    $checklistQuestions: [InspectionChecklistCMS]
  ) {
    data: updateTowerInspection(
      id: $id
      reviewerComments: $reviewerComments
      status: $status
      checklistQuestions: $checklistQuestions
    ) {
      id
      cmsStatus
      tower {
        id
        cmsStatus
        type {
          id
          name
        }
        builder {
          name
          certificateNumber
        }
        builderQualified
        site {
          id
          name
          location {
            lat
            lng
          }
          project {
            id
            name
            checklistType
            organisation {
              id
              name
            }
          }
        }
        environment
        platformHeight
        tag
        status
        notes
      }
      permissions {
        allowPDFExport
      }
      inspectionNumber
      status
      inspectedAt
      inspectedBy {
        name
      }
      reviewedBy {
        name
      }
      inspectorComments
      isExpired
      reviewerComments
      images {
        id
        url
      }
    }
  }
`;

export default async ({ client, params }) => {
  try {
    params?.checklistQuestions?.map((question) => {
      delete question["image.id"]
    })
    return client.mutate({
      mutation: updateTowerInspectionMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
